import type { AuthorContext } from "../api";
import { Badge } from "./ui";

export function AuthorContextSection({ data }: { data: AuthorContext }) {
  return (
    <div className="flex flex-col md:flex-row gap-7">
      <div className="md:w-56 shrink-0 flex flex-col gap-3">
        <span className="text-[0.65rem] uppercase tracking-[0.18em] text-gold-dark">
          About the author
        </span>
        <h3 className="font-serif text-2xl text-plum leading-tight">{data.author}</h3>
        {data.yearPublished ? (
          <div className="text-sm text-plum-soft italic">Published {data.yearPublished}</div>
        ) : null}
        {data.notableHonors?.length ? (
          <div className="flex flex-wrap gap-2 mt-1">
            {data.notableHonors.map((h, i) => (
              <Badge key={i} tone="gold">{h}</Badge>
            ))}
          </div>
        ) : null}
      </div>
      <div className="flex-1 border-l-0 md:border-l border-cream-200 md:pl-7">
        <p className="text-plum-soft leading-relaxed font-serif text-[1.0625rem]">{data.blurb}</p>
      </div>
    </div>
  );
}
